import { render, staticRenderFns } from "./JurnalGuruList.vue?vue&type=template&id=9852ca2a"
import script from "./JurnalGuruList.vue?vue&type=script&lang=js"
export * from "./JurnalGuruList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports